// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20717-查询预约日历 根据订单项ID查询近3天可预约的时间段，返回格式参考商品价格日历 POST /app/v1/order/booking-calendar */
export async function getBookingCalendar(
  body: API.SwimBookingCalendarQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimBookingCalendarAppVo>(
    "/app/v1/order/booking-calendar",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20705-订单取消 取消指定订单 GET /app/v1/order/cancel/${param0} */
export async function cancelOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.cancelOrderParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/app/v1/order/cancel/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 20704-订单创建（购物车） 通过购物车创建订单，支持全部创建或选择指定条目创建 POST /app/v1/order/createByCart */
export async function createOrderByCart(
  body: API.SwimOrderCreateByCartVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimOrderCreateRespVo>(
    "/app/v1/order/createByCart",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20703-订单创建（单个商品） 通过单个商品创建订单，需要指定时间段 POST /app/v1/order/createByGoods */
export async function createOrderByGoods(
  body: API.SwimOrderCreateByGoodsVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimOrderCreateRespVo>(
    "/app/v1/order/createByGoods",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20712-创建套餐商品订单 创建套餐商品订单，需要为每个子商品指定游泳者 POST /app/v1/order/createComboOrder */
export async function createComboOrder(
  body: API.SwimOrderCreateByComboVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimOrderCreateRespVo>(
    "/app/v1/order/createComboOrder",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20716-删除订单 删除指定订单，只有未支付或已取消状态的订单才允许删除 DELETE /app/v1/order/delete/${param0} */
export async function deleteOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteOrderParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/app/v1/order/delete/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 20702-订单详情查询 根据订单ID查询订单详情 GET /app/v1/order/detail/${param0} */
export async function getOrderDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getOrderDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimOrderAppDetailVo>(
    `/app/v1/order/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20709-可用订单项列表查询（快捷预约） 查询用户可用的订单项列表 POST /app/v1/order/item/list */
export async function getAvailableOrderItems(
  body: API.SwimOrderItemListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimOrderItemAppVo>(
    "/app/v1/order/item/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20701-订单列表查询 APP端分页查询订单列表 POST /app/v1/order/list */
export async function getOrderList(
  body: API.SwimOrderAppListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimOrderAppListVo>(
    "/app/v1/order/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20715-查询可支付订单数量 查询当前用户可支付的订单数量 GET /app/v1/order/payable/count */
export async function getPayableOrderCount(options?: { [key: string]: any }) {
  return request<API.YmResultVOInteger>("/app/v1/order/payable/count", {
    method: "GET",
    ...(options || {}),
  });
}

/** 20706-获取支付单 根据支付单ID获取支付单信息 GET /app/v1/order/payOrder/info/${param0} */
export async function getPayOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPayOrderParams,
  options?: { [key: string]: any }
) {
  const { payId: param0, ...queryParams } = params;
  return request<API.YmResultVOPayInfoVo>(
    `/app/v1/order/payOrder/info/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20708-订单退款 对订单项进行退款 POST /app/v1/order/refund/${param0} */
export async function refundOrder(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.refundOrderParams,
  body: API.SwimOrderRefundVo,
  options?: { [key: string]: any }
) {
  const { orderItemId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/app/v1/order/refund/${param0}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 20713-重新预约 对已预约的订单项进行重新预约，可能需要支付差价 POST /app/v1/order/reschedule */
export async function rescheduleOrder(
  body: API.SwimOrderRescheduleReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimOrderRescheduleRespVo>(
    "/app/v1/order/reschedule",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20719-计算重新预约差价 计算重新预约的差价，支持批量时间段选择 POST /app/v1/order/reschedule/calculatePriceDiff */
export async function calculateReschedulePriceDiff(
  body: API.SwimOrderRescheduleReqVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimReschedulePriceDiffVo>(
    "/app/v1/order/reschedule/calculatePriceDiff",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20714-取消重新预约 取消待支付差价的重新预约申请 GET /app/v1/order/reschedule/cancel/${param0} */
export async function cancelReschedule(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.cancelRescheduleParams,
  options?: { [key: string]: any }
) {
  const { rescheduleRecordId: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(
    `/app/v1/order/reschedule/cancel/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20718-重新预约商品价格日历 根据使用记录ID查询重新预约的商品价格日历，包含差价计算和时间冲突检查 GET /app/v1/order/reschedule/priceCalendar */
export async function getReschedulePriceCalendar(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getReschedulePriceCalendarParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGoodsPriceCalendarVo>(
    "/app/v1/order/reschedule/priceCalendar",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 20707-支付订单提交结算（已废弃，请使用21101） 提交支付订单进行结算 POST /app/v1/order/submit/payOrder */
export async function summitWxPay(
  body: API.SummitWxPayDto,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOWxPayResultVo>("/app/v1/order/submit/payOrder", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 20711-我的预约 查询用户的预约使用记录，queryType=1查询未使用记录，queryType=2查询历史记录 POST /app/v1/order/usage/list */
export async function getMyUsageList(
  body: API.SwimOrderUsageListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimOrderUsageAppVo>(
    "/app/v1/order/usage/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20710-预约使用 使用订单项进行预约 POST /app/v1/order/use */
export async function useOrder(
  body: API.SwimOrderUseVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/app/v1/order/use", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
